import PropTypes from 'prop-types';

// project imports
import useAuth from 'hooks/useAuth';
import PluginUnauthorized from '@/pages/plugin/PluginUnauthorized';
import { canAccessSubroot } from '../utils.jsx';

// ==============================|| PLUGIN LIBRARY GUARD ||============================== //
// The library opens only when this page load went through PluginAuthGuard, i.e. the page was
// opened by the plugin (/plugin?token=...&plugin_key=...) and the backend confirmed the
// plugin_key and the plugin connection. A reload (F5) of that same tab keeps the library open:
// JWTContext validates again the plugin_key kept in sessionStorage. Reaching the library from
// the address bar or another tab is rejected even with a valid session token, the user has to
// open it again from the plugin ("OPEN INBRIEF").

export default function PluginLibraryGuard({ children }) {
  const { isLoggedIn, pluginLoginDone, user } = useAuth();

  if (!isLoggedIn || !pluginLoginDone) {
    return <PluginUnauthorized reason="The library can only be opened from the plugin" />;
  }

  // the plugin session can't open the library under an organization the user can't see
  if (!canAccessSubroot(user)) {
    return <PluginUnauthorized reason="You don't have access to this organization" />;
  }

  return children;
}

PluginLibraryGuard.propTypes = { children: PropTypes.any };
